import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'

import App from './App.vue'
import 'primeicons/primeicons.css'
import './assets/main.css'
import i18n from './libs/i18n'
import { createSentry } from './libs/sentry'
import './libs/veeValidate'
import router from './router'

const Noir = definePreset(Aura, {
    semantic: {
        primary: {
            50:  'var(--color-primary-50)',
            100: 'var(--color-primary-100)',
            200: 'var(--color-primary-200)',
            300: 'var(--color-primary-300)',
            400: 'var(--color-primary-400)',
            500: 'var(--color-primary-500)',
            600: 'var(--color-primary-600)',
            700: 'var(--color-primary-700)',
            800: 'var(--color-primary-800)',
            900: 'var(--color-primary-900)',
            950: 'var(--color-primary-950)',
        },
    },
})

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(ConfirmationService)
app.use(ToastService)
app.directive('tooltip', Tooltip)
app.use(PrimeVue, {
    theme: {
        preset: Noir,
        options: {
            cssLayer: { name: 'primevue', order: 'theme, base, primevue' },
            darkModeSelector: '.dark',
        },
    },
})

createSentry(app)
app.use(router)

// Mount only once the router has resolved its initial navigation — including the auth guard's
// redirect to /login or /select-client. Until then #app stays blank, so the page never flashes the
// authenticated shell (App.vue's Default layout) before bouncing an unauthenticated user to login.
router.isReady().then(() => {
    app.mount('#app')
})
